module.exports = __webpack_public_path__ + "img/bingo_ball-44.744f203f.png";